export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12863.41a0307b.jpg";